const pokemonsDB = [
  {
    id: 4,
    img: "004",
    name: "Charmander",
    type: "fire",
    base_experience: 62,
  },
  { id: 5, img: "007", name: "Squirtle", type: "water", base_experience: 63 },
  { id: 7, img: "011", name: "Metapod", type: "bug", base_experience: 72 },
  {
    id: 9,
    img: "012",
    name: "Butterfree",
    type: "flying",
    base_experience: 178,
  },
  {
    id: 2,
    img: "025",
    name: "Pikachu",
    type: "electric",
    base_experience: 112,
  },
  {
    id: 8,
    img: "039",
    name: "Jigglypuff",
    type: "normal",
    base_experience: 95,
  },
  { id: 1, img: "094", name: "Gengar", type: "poison", base_experience: 225 },
  { id: 3, img: "133", name: "Eevee", type: "normal", base_experience: 65 },
];

export default pokemonsDB;
